import React from 'react';
import {
  priorityToDisplayMap,
  statusToDisplayTextMap
} from '../engine/TasksTabEngine';
import _Chip from '@material-ui/core/Chip';
import _CheckIcon from '@material-ui/icons/Check';
import _CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components/macro';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { priorityOptions, statusOptions } from '../engine/TasksTabEngine';
import formatDate from '../../../utils/formatDate';
import { DatePicker } from '@material-ui/pickers';
import InputBase from '../../form/InputBase';
import moment from '../../../utils/momentWithLocale';
import parseDate from '../../../utils/parseDate';
import UsersInputBoxEngine from '../../engine/UsersInputBoxEngine';
import MuiSelect from '@material-ui/core/Select';
import { StatusChip } from './TasksTabView';

const CheckIcon = styled(_CheckIcon)`
  color: #61a52b;
`;

const CloseIcon = styled(_CloseIcon)`
  color: #df8e82;
`;

const ShowButtonOnHoverDiv = styled.div`
  && {
    Button {
      opacity: 0;
    }
  }
  &&:hover {
    Button {
      opacity: 1;
    }
  }
`;

const Select = props => (
  <MuiSelect
    variant="outlined"
    inputProps={{ placeholder: 'Please choose an option.' }}
    // input={<OutlinedInput placeholder="Please choose an option." />}
    {...props}
  />
);

const PrioritySelect = styled(Select)`
  [class*='MuiSelect-root'] {
    padding: 3px;
    width: 12rem;
  }
`;

const StatusSelect = styled(Select)`
  [class*='MuiSelect-root'] {
    padding: 3px;
    width: 12rem;
  }
`;

const FieldEditorWrapper = styled.div`
  && {
    display: inline-block;
    vertical-align: middle;
    width: 275px;
  }
`;

const FieldValueWrapper = styled.div`
  && {
    display: inline-block;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: 275px;
  }
`;

const EditableTaskFieldView = props => {
  if (props.uiType === 'status') {
    if (props.isEditing) {
      return (
        <div>
          <FieldEditorWrapper>
            <StatusSelect value={props.showingValue} onChange={props.onChange}>
              {statusOptions.map(one => {
                return <MenuItem value={one.value}>{one.text}</MenuItem>;
              })}
            </StatusSelect>
          </FieldEditorWrapper>
          <IconButton onClick={props.onConfirmEdit} size="small">
            <CheckIcon size="small" />
          </IconButton>
          <IconButton onClick={props.onCancelEdit} size="small">
            <CloseIcon size="small" />
          </IconButton>
        </div>
      );
    } else {
      return (
        <ShowButtonOnHoverDiv>
          <StatusChip
            size="small"
            label={statusToDisplayTextMap[props.showingValue]}
            color="primary"
            $status={props.showingValue}
          />
          {props.isEditable ? (
            <IconButton
              size="small"
              onClick={() => {
                props.setIsEditing('status');
              }}
            >
              <EditIcon size="small" />
            </IconButton>
          ) : (
            ''
          )}
        </ShowButtonOnHoverDiv>
      );
    }
  } else if (props.uiType === 'user') {
    if (props.isEditing) {
      return (
        <div>
          <FieldEditorWrapper>
            <UsersInputBoxEngine
              useEnduserEndpoint
              isMulti={false}
              value={
                props.showingValue
                  ? { label: props.showingValue, value: props.value }
                  : null
              }
              onChange={props.onChange}
            />
          </FieldEditorWrapper>
          <IconButton onClick={props.onConfirmEdit} size="small">
            <CheckIcon />
          </IconButton>
          <IconButton onClick={props.onCancelEdit} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      );
    } else {
      return (
        <ShowButtonOnHoverDiv>
          <FieldValueWrapper>{props.showingValue}</FieldValueWrapper>
          {props.isEditable ? (
            <IconButton
              onClick={() => {
                props.setIsEditing(props.fieldId);
              }}
              size="small"
            >
              <EditIcon />
            </IconButton>
          ) : (
            ''
          )}
        </ShowButtonOnHoverDiv>
      );
    }
  } else if (props.uiType === 'priority') {
    if (props.isEditing) {
      return (
        <div>
          <FieldEditorWrapper>
            <PrioritySelect
              value={props.showingValue}
              onChange={props.onChange}
            >
              {priorityOptions.map(one => {
                return <MenuItem value={one.value}>{one.text}</MenuItem>;
              })}
            </PrioritySelect>
          </FieldEditorWrapper>
          <IconButton onClick={props.onConfirmEdit} size="small">
            <CheckIcon />
          </IconButton>
          <IconButton onClick={props.onCancelEdit} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      );
    } else {
      return (
        <ShowButtonOnHoverDiv>
          {priorityToDisplayMap[props.showingValue]}
          {props.isEditable ? (
            <IconButton
              onClick={() => {
                props.setIsEditing('priority');
              }}
              size="small"
            >
              <EditIcon />
            </IconButton>
          ) : (
            ''
          )}
        </ShowButtonOnHoverDiv>
      );
    }
  } else if (props.uiType === 'date') {
    if (props.isEditing) {
      return (
        <div>
          <FieldEditorWrapper>
            <DatePicker
              autoOk
              TextFieldComponent={InputBase}
              format={moment.localeData().longDateFormat('L')}
              value={props.showingValue ? parseDate(props.showingValue) : null}
              emptyLabel="Select date"
              onChange={props.onChange}
            />
          </FieldEditorWrapper>
          <IconButton onClick={props.onConfirmEdit} size="small">
            <CheckIcon />
          </IconButton>
          <IconButton onClick={props.onCancelEdit} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      );
    } else {
      return (
        <ShowButtonOnHoverDiv>
          {props.showingValue
            ? formatDate(+props.showingValue, false, 'DD/MM/YYYY', true)
            : ''}
          {props.isEditable ? (
            <IconButton
              onClick={() => {
                props.setIsEditing(props.fieldId);
              }}
              size="small"
            >
              <EditIcon />
            </IconButton>
          ) : (
            ''
          )}
        </ShowButtonOnHoverDiv>
      );
    }
  } else if (props.uiType === 'long_text') {
    if (props.isEditing) {
      return (
        <div>
          <FieldEditorWrapper>
            <TextField
              data-testid="description"
              multiline
              fullWidth
              rows={5}
              variant="outlined"
              label="Description"
              placeholder="Add a descripton"
              value={props.showingValue}
              onChange={props.onChange}
            />
          </FieldEditorWrapper>
          <IconButton onClick={props.onConfirmEdit} size="small">
            <CheckIcon />
          </IconButton>
          <IconButton onClick={props.onCancelEdit} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      );
    } else {
      return (
        <ShowButtonOnHoverDiv>
          {props.showingValue}
          {props.isEditable ? (
            <IconButton
              onClick={() => {
                props.setIsEditing(props.fieldId);
              }}
              size="small"
            >
              <EditIcon />
            </IconButton>
          ) : (
            ''
          )}
        </ShowButtonOnHoverDiv>
      );
    }
  } else if (props.uiType === 'text') {
    if (props.isEditing) {
      return (
        <div>
          <FieldEditorWrapper>
            <TextField
              data-testid="title"
              fullWidth
              variant="outlined"
              label="Title"
              placeholder="Add a title"
              value={props.showingValue}
              onChange={props.onChange}
            />
          </FieldEditorWrapper>
          <IconButton
            onClick={props.onConfirmEdit}
            size="small"
            disabled={props.required && !props.showingValue}
          >
            <CheckIcon
              color={props.required && !props.showingValue ? 'disabled' : ''}
            />
          </IconButton>
          <IconButton onClick={props.onCancelEdit} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      );
    } else {
      return (
        <ShowButtonOnHoverDiv>
          {props.showingValue}
          {props.isEditable ? (
            <IconButton
              onClick={() => {
                props.setIsEditing(props.fieldId);
              }}
              size="small"
            >
              <EditIcon />
            </IconButton>
          ) : (
            ''
          )}
        </ShowButtonOnHoverDiv>
      );
    }
  } else {
    return <>{props.showingValue}</>;
  }
};

export default EditableTaskFieldView;
